import React, { useEffect, useMemo, useState } from 'react';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const deadline = useMemo(() => Date.now() + 1000 * 60 * 60 * 24, []);
  const [remaining, setRemaining] = useState<number>(deadline - Date.now());
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()));
    }, 1000);
    return () => window.clearInterval(id);
  }, [deadline]);
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const units = [{
    value: hours,
    unit: 'hrs'
  }, {
    value: minutes,
    unit: 'min'
  }, {
    value: seconds,
    unit: 'sec'
  }];
  return <div className="w-full bg-teal text-cream" data-id="element-63" data-mp="anjjag0q3srh">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-2 px-4 text-center sm:h-12" data-id="element-64" data-mp="6n99stdq2k7v">
        <p className="text-[11px] font-bold uppercase tracking-[0.06em] sm:text-xs sm:tracking-[0.14em]" data-id="element-65" data-mp="13dhephmyys6c">
          <span aria-hidden="true" data-id="element-66" data-mp="18dn1okianqi3">⚡</span> Launch offer ends in:
        </p>
        <p className="flex items-baseline gap-1 text-[13px] font-bold tabular-nums sm:text-sm" role="timer" aria-live="off" data-id="element-67" data-mp="udc8hatihztr">
          {units.map((item, index) => <span key={item.unit} className="flex items-baseline gap-1" data-id="element-68" data-mp="1m4s39s582sv2" data-mpi={index}>
              {index > 0 && <span className="px-0.5 opacity-60" data-id="element-69" data-mp="1r3lh5lof8lvr">:</span>}
              <span data-id="element-70" data-mp="1r33di3zfj5dt">{pad(item.value)}</span>
              <span className="text-[9px] font-semibold uppercase tracking-wide text-cream/70" data-id="element-71" data-mp="1dc6lofdbus7t">
                {item.unit}
              </span>
            </span>)}
        </p>
      </div>
    </div>;
}